// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import KwPanel from '../../../common/KwPanel';

import { deletePlatform } from '../../../../actions/platformActions';
import { toast } from 'react-toastify';
import Button from '../../../common/Button';
import ConfirmationHeader from '../../../common/ConfirmationHeader';
import { useTranslation } from 'react-i18next';

function DeletePlatform({ done, id, cancel, deletePlatform }) {
  const { t } = useTranslation();
  const handleDelete = () => {
    deletePlatform(id)
      .then(() => {
        toast.success(t('Platform successfully deleted'));
        done();
      })
      .catch(() => {
        toast.error(t('Failed to delete platform'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Delete confirmation')}
      cancel={cancel}
      done={done}
    >
      <KwPanel>
        <ConfirmationHeader text={t('Are you sure?')} />
        <Button
          className="btn btn-danger me-2"
          onClick={handleDelete}
          text={t('Yes, delete the platform')}
        />
        <Button
          className="btn btn-default"
          onClick={cancel}
          autoFocus={true}
          text={t('No, cancel')}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}


function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = {
  deletePlatform,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeletePlatform);
